'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @fileoverview url相关
 * @author kirkzheng
 */

/**
 * 自动补全URL
 * @method
 * @param {String} url URL字符串
 * @param {Boolean} [isHttps = false] 是否https
 * @return {*|string}
 */
var autoFillUrl = exports.autoFillUrl = function autoFillUrl() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var isHttps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var re = /^([a-zA-Z0-9-]+\.)+([a-zA-Z]{2,4})(\/[a-zA-Z0-9`~!@#%&_=;$^*()\-+{}[\]:,.?/|]*)?$/;
    var protocols = ['http://', 'https://'];
    var result = url;

    if (re.test(url) && url.substr(0, 7) !== protocols[0] && url.substr(0, 8) !== protocols[1]) {
        result = (isHttps ? protocols[1] : protocols[0]) + url;
    }

    return result;
};

exports.default = {
    autoFillUrl: autoFillUrl
};